<!-- 由 suu 创建于 2021-12-27 星期一 -->
<template>
  <div class="die-selection">
    <!-- 头部 -->
    <img
      class="ds-top"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-nor-top"
      alt=""
    />
    <!-- 浮窗按钮 -->
    <div class="ds-fbtn user-btn" @click="toMyPrize">我的奖品</div>
    <div
      class="ds-fbtn ds-fbtn-rule user-btn"
      @click="$router.push('/die-selection-rule?showRef=1')"
    >
      活动规则
    </div>
    <!-- 营养师列表 -->
    <SelRanking :list="list" v-if="list" @call="handelCall"></SelRanking>
    <!-- 底部按钮 -->
    <div class="ds-footer">
      <div class="f-btn-end" v-if="[-1, -2].includes(voteNum)">
        {{ voteNum == -1 ? '活动已结束' : '活动未开始' }}
      </div>
      <template v-else>
        <div class="f-btn user-btn" @click="handelShare(false)">
          邀请好友帮忙
        </div>
        <div class="f-btn f-btn-2 user-btn" @click="bindClock">
          打卡赚投票
          <span>您还有{{ voteNum }}票可投</span>
        </div>
      </template>
    </div>
    <!-- 打Call弹窗 -->
    <SelCall
      :info="callInfo"
      @share="handelShare"
      @close="showCall = false"
      @success="init"
      @clock="bindClock"
      v-if="showCall"
    ></SelCall>
    <!-- 小程序分享引导 -->
    <van-overlay :show="showShare" @click="showShare = false">
      <div class="share-image-content">
        <img
          class="ds-share-img"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-guide?time=1224"
          alt=""
        />
      </div>
    </van-overlay>
    <!-- 海报 -->
    <SelPoster
      v-if="showPoster"
      :invitedCode="invitedCode"
      :curPerson="curPerson"
      @close="showPoster = false"
    ></SelPoster>
  </div>
</template>

<script>
import SelRanking from './ponents/sel-ranking'
import SelCall from './ponents/sel-call'
import SelPoster from './ponents/sel-poster'
export default {
  name: 'die-selection',

  components: { SelRanking, SelCall, SelPoster },

  props: {},

  data() {
    return {
      showPoster: false, // 海报
      curPerson: null, // 当前要分享的营养师信息
      invitedCode: '', // 转介串
      isMini: null, // 是否在小程序
      isAPP: false, // 是否在app
      isAppLogin: null, // app是否登录
      voteNum: 0,
      list: null,
      callInfo: null, // 当前打call 营养师
      showCall: false, // 打call 弹窗
      showShare: false // 小程序分享引导
    }
  },

  computed: {},

  watch: {},

  created() {
    let isFirst = localStorage.getItem('delAutoRuled')
    if (!isFirst) {
      localStorage.setItem('delAutoRuled', 1)
      this.$router.push('/die-selection-rule')
      return
    }
    if (this.$http._isApp()) {
      this.isAPP = true
      this.$betterwe.isLogin(() => {
        this.getStr()
      })
    } else {
      wx.miniProgram.getEnv((res) => {
        this.isMini = res.miniprogram
        // 回调放在里面
        this.getStr()
      })
    }
    this.init()
  },

  mounted() {},

  destroyed() {},

  methods: {
    toMyPrize() {
      if (this.isMini) {
        wx.miniProgram.navigateTo({
          url: '/pages/call-for-love/my-prize/index'
        })
      } else {
        if (this.isAppLogin !== 1) {
          let obj = {
            path: '/loginPhone'
          }
          this.$betterwe.onAppPageRoute(obj)
          return
        }
        this.$router.push('/die-selection-pro')
      }
    },
    bindClock() {
      this.addLog('明星减脂营-营养师评选获取额外票数')
      if (this.isAPP) {
        if (this.isAppLogin !== 1) {
          let obj = {
            path: '/loginPhone'
          }
          this.$betterwe.onAppPageRoute(obj)
          return
        }
        this.$betterwe.onAppPageRoute({
          path: '/ugcPublish', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'activityType', value: 1 },
            { key: 'tabIndex', value: 1 }
          ]
        })
      } else if (this.isMini) {
        let topic = {
          id: 16
        }
        wx.miniProgram.navigateTo({
          url:
            '/pages/publish/publish?publishType=1&topic=' +
            JSON.stringify(topic)
        })
      }
    },
    /**
     * 打call
     */
    handelCall(item) {
      if (this.isApp && this.isAppLogin !== 1) {
        let obj = {
          path: '/loginPhone'
        }
        this.$betterwe.onAppPageRoute(obj)
        return
      }
      if ([-1, -2].includes(this.voteNum)) {
        this.$toast(`${this.voteNum == -1 ? '活动已结束' : '活动未开始'}`)
        return
      }
      this.callInfo = item
      this.callInfo['voteNum'] = this.voteNum
      this.showCall = true
    },
    /**
     * 分享配置 小程序  APP 是否是邀请好友为营养师打call
     */
    handelShare(info) {
      this.addLog('明星减脂营-营养师评选邀请好友')
      if (this.isAPP) {
        if (this.isAppLogin !== 1) {
          let obj = {
            path: '/loginPhone'
          }
          this.$betterwe.onAppPageRoute(obj)
          return
        }
        // app分享配置
        this.curPerson = info || null
        this.showPoster = true
      } else if (this.isMini) {
        // 小程序分享配置
        let params = {
          title: info
            ? '帮我一起为' +
              (info.c_name || '营养师') +
              '打call，领取100元优惠礼包！'
            : '为喜爱的营养师打call，领取100元优惠礼包！',
          imageUrl: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-share'
        }
        this.setWxShare(params)
        this.showShare = true
      }
    },
    //设置微信分享或者转发
    setWxShare({ title, imageUrl }) {
      const link = location.origin + location.pathname
      const miniObj = {
        title: title,
        imageUrl,
        path:
          '/pages/webview/webview?url=' +
          encodeURIComponent(link) +
          `&invitedCode=${this.invitedCode}`
      }
      console.log(miniObj)
      wx.miniProgram.postMessage({
        data: miniObj
      })
    },
    /**
     * 初始化信息
     */
    init() {
      this.getInfo()
      this.getVote()
    },
    /**
     * 获取投票数
     */
    getVote() {
      this.$http.getApp('member/AppVote/getVote', {}).then((res) => {
        if (res.data.code == 200) {
          this.voteNum = res.data.data
        } else if (res.data.code == 4001) {
          this.voteNum = -2
        }
        // this.voteNum = -1
      })
    },
    /**
     * 埋点
     */
    addLog(from) {
      this.$http
        .getApp('member/StorageLogin/spotLog', { from, type: 3 })
        .then((res) => {})
    },
    /**
     * 获取活动信息
     */
    getInfo() {
      this.$http.getApp('member/AppVote/getRanking', {}).then((res) => {
        this.list = res.data.data
      })
    },
    /**
     * 获取转介串
     */
    getStr() {
      // 先判断app  满足 return
      if (this.isAPP) {
        // xxx
        this.$http
          .getApp('member/AppVote/getRandStr', {
            channel_id: 1,
            type: 1
          })
          .then((res) => {
            this.invitedCode = res.data.data
          })
      } else {
        // 判断 小程序
        this.$http
          .getApp('member/AppVote/getRandStr', {
            channel_id: 1,
            type: 2
          })
          .then((res) => {
            this.invitedCode = res.data.data
            if (this.isMini) {
              // 小程序分享配置
              let params = {
                title: '为喜爱的营养师打call，领取100元优惠礼包！',
                imageUrl:
                  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-share'
              }
              this.setWxShare(params)
            }
          })
        // }
        // })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.die-selection {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 70px;
  background: #fff1f0;
  .ds-top {
    width: 100%;
    box-sizing: border-box;
  }
  .ds-fbtn {
    width: 28px;
    height: 72px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 0;
    top: 36px;
    background: #ee484b;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
    padding: 0 8px;
    line-height: 13px;
    font-weight: 450;
  }
  .ds-fbtn-rule {
    top: 113px;
    background: #292b49;
  }
  .ds-footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    font-size: 18px;
    font-family: eryazhenyuanjian;
    color: #ffffff;
    .f-btn {
      width: 50%;
      height: 52px;
      box-sizing: border-box;
      background: #9c79cf;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
    }
    .f-btn-2 {
      background: linear-gradient(207deg, #f28a6c 0%, #ed629b 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .f-btn-end {
      width: 100%;
      height: 52px;
      box-sizing: border-box;
      background: #999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .share-image-content {
    display: flex;
    justify-content: flex-end;
    .ds-share-img {
      width: 65%;
      height: auto;
    }
  }
}
</style>
